module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topic-menu-frame"
  }, [_vm._l((_vm.topic.menus), function(menu, index) {
    return _c('LevelBlock', {
      key: menu,
      attrs: {
        "menu": menu,
        "index": index,
        "container": _vm.topic.menus,
        "editMode": _vm.topic.editMode
      }
    })
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.topic.editMode),
      expression: "topic.editMode"
    }],
    staticClass: "level add",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.topic.addMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("\n\t\t添加菜单\n\t")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-7e1860cb"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/backyard/view/topic/widget/TopicMenuFrame.vue
// module id = 1008
// module chunks = 1